import { useCallback } from "react";

import Button from "hardcover-ui/components/Button";
import Icon from "hardcover-ui/components/Icon";
import faChevronLeft from "icons/solid/chevron-left.svg";

export default function BackLink({ className = "" }: { className?: string }) {
  const handleGoBack = useCallback(() => window.history.back(), []);

  return (
    <Button
      onClick={handleGoBack}
      className={`${className} dark:text-gray-400 text-stone-800 font-medium`}
    >
      <Icon icon={faChevronLeft} /> <span>Back</span>
    </Button>
  );
}
